import { render, staticRenderFns } from "./dataV_B.vue?vue&type=template&id=4b38c202&scoped=true&"
import script from "./dataV_B.vue?vue&type=script&lang=js&"
export * from "./dataV_B.vue?vue&type=script&lang=js&"
import style0 from "./dataV_B.vue?vue&type=style&index=0&id=4b38c202&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b38c202",
  null
  
)

export default component.exports